import React, { useEffect, useState } from 'react'
import {Tooltip, OverlayTrigger } from "react-bootstrap";
import infoIcon from "../../public/assets/info-circle.svg"
import styles from "./infoBox.module.css"
import infoIconWhite from "../../public/assets/infoiconwhite.svg"

function InfoBox({content, show="true", image=infoIcon, color="", size="", place = "bottom"}) {
const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (show && content && content.length > 0) {
      setShowTooltip(true);
      const timeout = setTimeout(() => {
        setShowTooltip(false);
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [content]);
    
  return (
    <span>
          {content && content.length > 0 ?
          <OverlayTrigger
          show={showTooltip}
            placement={place}
            trigger={true}
            overlay={
              <Tooltip>
              {content}
              </Tooltip>
            }
            >
            {React.isValidElement(image) ? (
            <span 
              className={styles.toopTipImage}
              style={size !== "" ? { height: size, width: size, borderRadius: "50%" } : {}}
              onMouseOver={() => setShowTooltip(true)}
              onMouseOut={() => setShowTooltip(false)}
            >
              {image}
            </span>
          ) : (
            <img 
              src={color === "white" ? infoIconWhite : image} 
              alt="" 
              className={styles.toopTipImage}
              style={size !== "" ? { height: size, width: size, borderRadius: "50%" } : { height: "16px", width: "16px" }}
              onMouseOver={() => setShowTooltip(true)}
              onMouseOut={() => setShowTooltip(false)}
            />
          )}
          </OverlayTrigger> : ""}
        </span>
  )
}

export default InfoBox